<div>
  <div class="top">
    <app-menu></app-menu>
    <app-tabs></app-tabs>
  </div>
</div>
